import _pick from 'ramda/src/pick';
import _map from 'ramda/src/map';
import capsizesJson from '@hover/tokens-typography/assets/capsizes.next.json';
import * as tokens from '@hover/tokens-typography/next';
import * as tokens$1 from '@hover/tokens-color/next';
import * as tokens$2 from '@hover/tokens-border/next';

var presets$1 = {
  100: {
    color: tokens.heading100Color,
    fontFamily: tokens.heading100Family,
    fontSize: tokens.heading100Size,
    fontWeight: tokens.heading100Weight,
    lineHeight: tokens.heading100Height,
    marginBottom: tokens.heading100Margin,
    letterSpacing: tokens.heading100LetterSpacing
  },
  200: {
    color: tokens.heading200Color,
    fontFamily: tokens.heading200Family,
    fontSize: tokens.heading200Size,
    fontWeight: tokens.heading200Weight,
    lineHeight: tokens.heading200Height,
    marginBottom: tokens.heading200Margin,
    letterSpacing: tokens.heading200LetterSpacing
  },
  300: {
    fontWeight: tokens.heading300Weight,
    fontFamily: tokens.heading300Family,
    color: tokens.heading300Color,
    fontSize: tokens.heading300Size,
    lineHeight: tokens.heading300Height,
    marginBottom: tokens.heading300Margin,
    letterSpacing: tokens.heading300LetterSpacing
  },
  400: {
    fontWeight: tokens.heading400Weight,
    color: tokens.heading400Color,
    fontFamily: tokens.heading400Family,
    fontSize: tokens.heading400Size,
    lineHeight: tokens.heading400Height,
    marginBottom: tokens.heading400Margin,
    letterSpacing: tokens.heading400LetterSpacing
  },
  500: {
    fontWeight: tokens.heading500Weight,
    color: tokens.heading500Color,
    fontFamily: tokens.heading500Family,
    fontSize: tokens.heading500Size,
    lineHeight: tokens.heading500Height,
    marginBottom: tokens.heading500Margin,
    letterSpacing: tokens.heading500LetterSpacing
  },
  600: {
    fontWeight: tokens.heading600Weight,
    color: tokens.heading600Color,
    fontFamily: tokens.heading600Family,
    fontSize: tokens.heading600Size,
    lineHeight: tokens.heading600Height,
    marginBottom: tokens.heading600Margin,
    letterSpacing: tokens.heading600LetterSpacing
  },
  /**
   * @deprecated use 600
   */
  650: {
    fontWeight: tokens.heading650Weight,
    color: tokens.heading650Color,
    fontFamily: tokens.heading650Family,
    fontSize: tokens.heading650Size,
    lineHeight: tokens.heading650Height,
    marginBottom: tokens.heading650Margin,
    letterSpacing: tokens.heading650LetterSpacing
  },
  700: {
    fontWeight: tokens.heading700Weight,
    color: tokens.heading700Color,
    fontFamily: tokens.heading700Family,
    fontSize: tokens.heading700Size,
    lineHeight: tokens.heading700Height,
    marginBottom: tokens.heading700Margin,
    letterSpacing: tokens.heading700LetterSpacing
  },
  800: {
    fontWeight: tokens.heading800Weight,
    color: tokens.heading800Color,
    fontFamily: tokens.heading800Family,
    fontSize: tokens.heading800Size,
    lineHeight: tokens.heading800Height,
    marginBottom: tokens.heading800Margin,
    letterSpacing: tokens.heading800LetterSpacing
  },
  900: {
    fontWeight: tokens.heading900Weight,
    color: tokens.heading900Color,
    fontFamily: tokens.heading900Family,
    fontSize: tokens.heading900Size,
    lineHeight: tokens.heading900Height,
    marginBottom: tokens.heading900Margin,
    letterSpacing: tokens.heading900LetterSpacing
  }
};
var aliases$1 = {
  xs: 100,
  small: 200,
  medium: 400,
  large: 600,
  xl: 700,
  xxl: 900
};
var sizes$1 = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight', 'letterSpacing']), presets$1);
var capsizes$1 = capsizesJson.heading;

var presets = {
  200: {
    color: tokens.body200Color,
    fontFamily: tokens.body200Family,
    fontSize: tokens.body200Size,
    fontWeight: tokens.body200Weight,
    lineHeight: tokens.body200Height
  },
  300: {
    fontWeight: tokens.body300Weight,
    fontFamily: tokens.body300Family,
    color: tokens.body300Color,
    fontSize: tokens.body300Size,
    lineHeight: tokens.body300Height
  },
  400: {
    fontWeight: tokens.body400Weight,
    fontFamily: tokens.body400Family,
    color: tokens.body400Color,
    fontSize: tokens.body400Size,
    lineHeight: tokens.body400Height
  },
  500: {
    fontWeight: tokens.body500Weight,
    fontFamily: tokens.body500Family,
    color: tokens.body500Color,
    fontSize: tokens.body500Size,
    lineHeight: tokens.body500Height
  },
  600: {
    fontWeight: tokens.body600Weight,
    fontFamily: tokens.body600Family,
    color: tokens.body600Color,
    fontSize: tokens.body600Size,
    lineHeight: tokens.body600Height
  }
};
var aliases = {
  footnote: 200,
  small: 300,
  medium: 400
};
var sizes = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight']), presets);
var capsizes = capsizesJson.body;

var colors = {
  primary: {
    50: tokens$1.primary50,
    100: tokens$1.primary100,
    200: tokens$1.primary200,
    300: tokens$1.primary300,
    400: tokens$1.primary400,
    500: tokens$1.primary500,
    600: tokens$1.primary600,
    700: tokens$1.primary700,
    800: tokens$1.primary800,
    900: tokens$1.primary900,
    base: tokens$1.primaryBase
  },
  secondary: {
    100: tokens$1.secondary100,
    200: tokens$1.secondary200,
    300: tokens$1.secondary300,
    400: tokens$1.secondary400,
    500: tokens$1.secondary500,
    600: tokens$1.secondary600,
    700: tokens$1.secondary700,
    800: tokens$1.secondary800,
    900: tokens$1.secondary900,
    base: tokens$1.secondaryBase
  },
  neutral: {
    0: tokens$1.neutral0,
    100: tokens$1.neutral100,
    200: tokens$1.neutral200,
    300: tokens$1.neutral300,
    400: tokens$1.neutral400,
    500: tokens$1.neutral500,
    50: tokens$1.neutral50,
    550: tokens$1.neutral550,
    600: tokens$1.neutral600,
    700: tokens$1.neutral700,
    750: tokens$1.neutral750,
    800: tokens$1.neutral800,
    850: tokens$1.neutral850,
    900: tokens$1.neutral900,
    background: tokens$1.neutralBackground,
    backgroundDark: tokens$1.neutralBackgroundDark,
    card: tokens$1.neutralCard,
    disabled: tokens$1.neutralDisabled,
    secondaryText: tokens$1.neutralSecondaryText,
    stroke: tokens$1.neutralStroke,
    text: tokens$1.neutralText,
    textLight: tokens$1.neutralTextLight
  },
  success: {
    50: tokens$1.success50,
    100: tokens$1.success100,
    200: tokens$1.success200,
    300: tokens$1.success300,
    400: tokens$1.success400,
    500: tokens$1.success500,
    600: tokens$1.success600,
    700: tokens$1.success700,
    800: tokens$1.success800,
    900: tokens$1.success900,
    base: tokens$1.successBase
  },
  warning: {
    50: tokens$1.warning50,
    100: tokens$1.warning100,
    200: tokens$1.warning200,
    300: tokens$1.warning300,
    400: tokens$1.warning400,
    500: tokens$1.warning500,
    600: tokens$1.warning600,
    700: tokens$1.warning700,
    800: tokens$1.warning800,
    900: tokens$1.warning900,
    base: tokens$1.warningBase
  },
  danger: {
    50: tokens$1.danger50,
    100: tokens$1.danger100,
    200: tokens$1.danger200,
    300: tokens$1.danger300,
    400: tokens$1.danger400,
    500: tokens$1.danger500,
    600: tokens$1.danger600,
    700: tokens$1.danger700,
    800: tokens$1.danger800,
    900: tokens$1.danger900,
    base: tokens$1.dangerBase
  },
  brandNavy: {
    100: tokens$1.brandNavy100,
    200: tokens$1.brandNavy200,
    300: tokens$1.brandNavy300,
    400: tokens$1.brandNavy400,
    500: tokens$1.brandNavy500,
    600: tokens$1.brandNavy600,
    700: tokens$1.brandNavy700,
    800: tokens$1.brandNavy800,
    900: tokens$1.brandNavy900
  },
  brandGreen: {
    100: tokens$1.brandGreen100,
    200: tokens$1.brandGreen200,
    300: tokens$1.brandGreen300,
    400: tokens$1.brandGreen400,
    500: tokens$1.brandGreen500,
    600: tokens$1.brandGreen600,
    700: tokens$1.brandGreen700,
    800: tokens$1.brandGreen800,
    900: tokens$1.brandGreen900
  },
  brandBrown: {
    100: tokens$1.brandBrown100,
    200: tokens$1.brandBrown200,
    300: tokens$1.brandBrown300,
    400: tokens$1.brandBrown400,
    500: tokens$1.brandBrown500,
    600: tokens$1.brandBrown600,
    700: tokens$1.brandBrown700,
    800: tokens$1.brandBrown800,
    900: tokens$1.brandBrown900
  },
  brandRed: {
    100: tokens$1.brandRed100,
    200: tokens$1.brandRed200,
    300: tokens$1.brandRed300,
    400: tokens$1.brandRed400,
    500: tokens$1.brandRed500,
    600: tokens$1.brandRed600,
    700: tokens$1.brandRed700,
    800: tokens$1.brandRed800,
    900: tokens$1.brandRed900
  },
  brandTan: {
    100: tokens$1.brandTan100,
    200: tokens$1.brandTan200,
    300: tokens$1.brandTan300,
    400: tokens$1.brandTan400,
    500: tokens$1.brandTan500,
    600: tokens$1.brandTan600,
    700: tokens$1.brandTan700,
    800: tokens$1.brandTan800,
    900: tokens$1.brandTan900
  },
  brandOrange: {
    100: tokens$1.brandOrange100,
    200: tokens$1.brandOrange200,
    300: tokens$1.brandOrange300,
    400: tokens$1.brandOrange400,
    500: tokens$1.brandOrange500,
    600: tokens$1.brandOrange600,
    700: tokens$1.brandOrange700,
    800: tokens$1.brandOrange800,
    900: tokens$1.brandOrange900
  },
  brandYellow: {
    100: tokens$1.brandYellow100,
    200: tokens$1.brandYellow200,
    300: tokens$1.brandYellow300,
    400: tokens$1.brandYellow400,
    500: tokens$1.brandYellow500,
    600: tokens$1.brandYellow600,
    700: tokens$1.brandYellow700,
    800: tokens$1.brandYellow800,
    900: tokens$1.brandYellow900
  },
  brandPurple: {
    100: tokens$1.brandPurple100,
    200: tokens$1.brandPurple200,
    300: tokens$1.brandPurple300,
    400: tokens$1.brandPurple400,
    500: tokens$1.brandPurple500,
    600: tokens$1.brandPurple600,
    700: tokens$1.brandPurple700,
    800: tokens$1.brandPurple800,
    900: tokens$1.brandPurple900
  },
  lightAlpha: {
    50: tokens$1.lightAlpha50,
    100: tokens$1.lightAlpha100,
    200: tokens$1.lightAlpha200,
    300: tokens$1.lightAlpha300,
    400: tokens$1.lightAlpha400,
    500: tokens$1.lightAlpha600,
    600: tokens$1.lightAlpha600,
    700: tokens$1.lightAlpha700,
    800: tokens$1.lightAlpha800,
    900: tokens$1.lightAlpha900
  },
  darkAlpha: {
    50: tokens$1.darkAlpha50,
    100: tokens$1.darkAlpha100,
    200: tokens$1.darkAlpha200,
    300: tokens$1.darkAlpha300,
    400: tokens$1.darkAlpha400,
    500: tokens$1.darkAlpha600,
    600: tokens$1.darkAlpha600,
    700: tokens$1.darkAlpha700,
    800: tokens$1.darkAlpha800,
    900: tokens$1.darkAlpha900
  },
  overlayLight: tokens$1.overlayLight,
  overlayDark: tokens$1.overlayDark,
  halo: {
    primary: tokens$1.haloPrimary,
    neutral: tokens$1.haloNeutral,
    warning: tokens$1.haloWarning,
    danger: tokens$1.haloDanger,
    success: tokens$1.haloSuccess
  },
  ring: {
    primary: tokens$1.ringPrimary,
    neutral: tokens$1.ringNeutral
  },
  border: {
    danger: tokens$1.borderDanger,
    disabled: tokens$1.borderDisabled,
    focus: tokens$1.borderFocus,
    focusDanger: tokens$1.borderFocusDanger,
    focusNeutral: tokens$1.borderFocusNeutral,
    focusSuccess: tokens$1.borderFocusSuccess,
    focusWarning: tokens$1.borderFocusWarning,
    idle: tokens$1.borderIdle,
    invalid: tokens$1.borderInvalid,
    invalidFocus: tokens$1.borderInvalidFocus,
    neutral: tokens$1.borderNeutral,
    primary: tokens$1.borderPrimary
  }
};

var radii = {
  200: tokens$2.radius200,
  300: tokens$2.radius300,
  350: tokens$2.radius350,
  400: tokens$2.radius400,
  450: tokens$2.radius450,
  500: tokens$2.radius500,
  550: tokens$2.radius550,
  900: tokens$2.radius900,
  round: tokens$2.radiusRound
};

export { aliases$1 as a, aliases as b, capsizes$1 as c, sizes as d, presets as e, capsizes as f, colors as g, presets$1 as p, radii as r, sizes$1 as s };
